import { createContext } from "react";

import { UserGetMyselfResponseType } from "../api/responses/userResponseTypes";

import type {
  UserType,
  GroupType,
  PolicyType,
  AttributeMetadataType,
  ScopeType
} from "../api/types";

export type DataContextType = {
  users: UserType[];
  groups: GroupType[];
  myself?: UserGetMyselfResponseType;
  policies: PolicyType[];
  attributeMetadatas: AttributeMetadataType[];
  scopes: ScopeType[];
  fetchUsers: () => void;
  fetchGroups: () => void;
  fetchMyself: () => Promise<void>;
  fetchPolicies: () => void;
  fetchAttributeMetadatas: () => void;
  fetchScopes: () => void;
};

const initialState: DataContextType = {
  users: [],
  groups: [],
  policies: [],
  attributeMetadatas: [],
  scopes: [],
  fetchUsers: () => {},
  fetchGroups: () => {},
  fetchMyself: () => Promise.reject(),
  fetchPolicies: () => {},
  fetchAttributeMetadatas: () => {},
  fetchScopes: () => {}
};

export default createContext(initialState);
